import { Users } from 'lucide-react';
import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { NotificationSound } from "../../CommonComponents/CommonNotification";
import { ApiCall } from "../../CommonComponents/CustomHooks";
import { initializeFilterData } from "../../CommonComponents/EnvConfig";
import { handleDownloadExcel } from "../../CommonComponents/ExportData";
import { FormButton } from "../../CommonComponents/InputBox";
import { Table } from "../../CommonComponents/Table";
import { setSubLoading } from "../../Redux/Services/AuthSlice";

const PendingFollowUpLeadEntry = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
   
    const getGroupMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/LeadEntry/PendingFollowUpLeadEntry`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res);
        } else if (res.Status === 'ERROR') {
            setTableData([]);
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getGroupMasterData(value);
    };
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    useEffect(() => {
        //inputrefs.current['txtDateType'].focus()
        document.title = 'Pending Follow Up Lead Entry'
        getGroupMasterData()
    }, [sortConfig]);

    return (
        <>
                <div className='bg-white rounded-lg shadow-sm p-6 mb-6'>
                    <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-2">
                            <Users className="w-6 h-6 text-teal-600" />
                            <h2 className="text-xl font-semibold text-gray-800">Pending Follow Up Lead Entry</h2>
                        </div>
                    </div>
                    <div className='card-body pb-1'>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            save={false}
                            Reset={false }
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/LeadEntry/LeadEntryReport`, filterData, 'Lead Entry Report')
                                await dispatch(setSubLoading(false))
                            }}
                        />
                    </div>
                </div>
                <Table
                    loading={isLoading}
                    PageName={'PendingFollowUpLeadEntry'}
                    handleFilter={() => {
                        getGroupMasterData(1)
                        setFilterData({
                            ...filterData,
                        })
                    }}
                    filterData={filterData}
                    tableData={tableData}
                    setFilterData={setFilterData}
                    currentPageNo={currentPageNo}
                    handleChange1={handleChange1}
                    handleSorting={handleSorting}
                    sortConfig={sortConfig}
                />
        </>
    )
}
export default PendingFollowUpLeadEntry;